// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/warning-with-circle-background-white.svg';

export const WarningWithCircleBackgroundWhite = (props: SvgIconProps) => (
    <SvgIcon
        component={Svg}
        inheritViewBox
        style={{ width: 64, height: 64 }}
        {...props}
    />
);
